import React, { useEffect, useState, useCallback } from "react";
import { unstable_batchedUpdates } from 'react-dom';
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../redux/actions/emailAction";
import { getCspsInformationsData, genPreDiuoPDF, getPreDiuoFile } from "../Utils";
import { Button } from "@material-ui/core";
import { Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from "@material-ui/icons";
import history from "../../Routes/history";
import Header from "../../Header/Header";
import DocMenu from "../../DocMenu";
import NumDossPreDiuo from "../../NumDossPreDiuo";
import GenPdf from "../../GenPdf";
import { documentToProvideConst } from "./Const";
import LoadingOverlay from "../../LoadingOverlay";
import "../../../Styles/PreDIUO/Page2.scss";

const PreDiuoPage2 = () => {
  const dispatch = useDispatch();
  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const index = useSelector((state) => state.preDiuo.index);
  const preDiuoValue = useSelector((state) => state.preDiuo.preDiuoValue);

  const [isLoading, setIsLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [documentToProvide, setDocumentToProvide] = useState(documentToProvideConst);

  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);

  const loadData = async () => {
    if (!preDiuoValue) return resetData();
    setIsLoading(true);
    const responseCspsInformationsData = await getCspsInformationsData(dossierValue, preDiuoValue);


    if (responseCspsInformationsData) {
      const documentToProvideLoaded = responseCspsInformationsData.document_to_provide ? JSON.parse(responseCspsInformationsData.document_to_provide) : documentToProvideConst;

      unstable_batchedUpdates(() => {
        setDocumentToProvide(documentToProvideLoaded);
        setIsLoading(false);
      });
    } else {
      unstable_batchedUpdates(() => {
        resetData();
        setIsLoading(false);
      });
    }
  };

  useEffect(() => {
    if (!dossierValue) return
    loadData()

  }, [preDiuoValue]);

  const resetData = () => {
    setDocumentToProvide(documentToProvideConst);
  }

  const handleChangeDocumentToProvideValues = (event, index) => {
    const { name, checked } = event.target;

    setDocumentToProvide(prevState => {
      const element = [...prevState];
      element[index] = {
        ...element[index],
        [name]: checked,
        [name === "yes" ? "no" : "yes"]: !checked
      }
      return element
    })
  }

  const handleSaveData = async () => {
    setDisableButton(true);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        preDiuoValue,
        documentToProvide: JSON.stringify(documentToProvide)
      }),
    };
    try {
      const response = await fetch("/api/prediuo/updateCspsInformationsData", requestOptions);
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDisableButton(false);
    }
  }

  const handleGenClick = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genPreDiuoPDF(preDiuoValue, dossierValue, index);
    if (blob) {
      setIsOpen(true);
      setFile(blob);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleShowPdf = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleGetPdfFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.type === 'application/pdf') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleGetWordFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleChangeTitleName = useCallback(() => {
    dispatch(changeTitleName(`Pré DIUO`));
  }, [preDiuoValue]);

  const prevPage = () => {
    history.push("/prediuo/page1");
  }

  const nextPage = () => {
    history.push("/prediuo/page3");
  }

  return (
    <div className="pre-diuo-page2">
      {isLoading && <LoadingOverlay />}
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
        updateIndication={() => dispatch(changeIndication(index))}
      />
      <h1 className="title">Pré DIUO (Document et pièce fournis au CSPS)</h1>
      <NumDossPreDiuo />
      <div className="container">
        <table className="custom-table">
          <thead>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" style={{ width: '50px' }}><strong>Oui</strong></td>
              <td className="custom-cell-label" style={{ width: '50px' }}><strong>Non</strong></td>
              <td className="custom-cell-label" colSpan={2}><strong>Type de document</strong></td>
            </tr>
          </thead>
          <tbody>
            {documentToProvide.map((item, index) => (
              <tr className="custom-cell" key={`document-to-provide-${index}`}>
                <td className="custom-cell-label"><input name="yes" type="checkbox" checked={item.yes} onChange={(event) => handleChangeDocumentToProvideValues(event, index)} /></td>
                <td className="custom-cell-label"><input name="no" type="checkbox" checked={item.no} onChange={(event) => handleChangeDocumentToProvideValues(event, index)} /></td>
                <td className="custom-cell-label" colSpan={2}><span>{item.type}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="buttons-container">
        <Button
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSaveData}
          disabled={disableButton || !preDiuoValue}
        >
          Enregistrer
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<PdfIcon />}
          onClick={handleGenClick}
          disabled={disableButton || !preDiuoValue}
        >
          Générer
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<VisibilityIcon />}
          onClick={() => handleShowPdf()}
          disabled={disableButton || !preDiuoValue}
        >
          Afficher
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={prevPage}
          disabled={disableButton || !preDiuoValue}
        >
          Précedent
        </Button>
        <Button
          color="primary"
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={nextPage}
          disabled={disableButton || !preDiuoValue}
        >
          Suivant
        </Button>
        {disableButton && (
          <CircularProgress className="spinner" color="inherit" />
        )}
      </div>
      <GenPdf
        file={file}
        isOpen={isOpen}
        closeDoc={() => setIsOpen(false)}
        scale={1}
      />
    </div>
  );
};

export default PreDiuoPage2;